import type { CreditSummaryData, CreditSummary, LinkedAccount, PeriodSummary } from '../types/credits.types';
import { formatDate } from '@chikara/utils';


export function mapCreditSummaryData(data: CreditSummaryData): CreditSummary {
  const spentAmount = data?.credit_line - data?.available < 0 ? 0 : data?.credit_line - data?.available;
  return {
    creditLine: data?.credit_line || 0,
    spent: spentAmount,
    available: data?.available || 0,
    toPayAmount: data?.payment_obligation?.amount || 0,
    toPayDate: formatDate(data?.payment_obligation?.deadline) || 'Sin información',
  };
}

export function mapLinkedAccount(data: CreditSummaryData): LinkedAccount {
  return {
    accountName: data?.deposit_info?.account_tag || 'Sin información',
    clabe: data?.deposit_info?.clabe || 'Sin información',
    bankName: data?.deposit_info?.bank_name || 'Sin información',
  };
}

export function mapPeriodSummary(data: CreditSummaryData): PeriodSummary {
  const getDaysUntil = (deadline: string): number => {
    const now = new Date();
    const target = new Date(deadline);

    const diffMs = target.getTime() - now.getTime();

    return Math.ceil(diffMs / (1000 * 60 * 60 * 24)) || 0;
  };

  return {
    periodStartDate: formatDate(data?.period_breakdown?.start_date) || 'Sin información',
    paymentDueDate: formatDate(data?.payment_obligation?.deadline) || 'Sin información',
    cutoffDate: formatDate(data?.period_breakdown?.end_date) || 'Sin información',
    nextCutoffDate: formatDate(data?.period_breakdown?.next_cutoff_day) || 'Sin información',
    balanceDate: formatDate(new Date().toISOString()),
    periodStartBalance: data?.period_breakdown?.opening_balance || 0,
    charges: data?.period_breakdown?.charges || 0,
    credits: data?.period_breakdown?.payments || 0,
    interestAndFees: data?.period_breakdown?.interest_fee || 0,
    currentBalance: data?.period_breakdown?.current_balance || 0,
    cutoffInDays: getDaysUntil(data?.period_breakdown?.end_date || 'Sin información'),
  };
}
